export const trackComparableListingProperties = (payload, properties) => {
  if (payload.comparableListings) {
    const selectedListings = payload.comparableListings.filter(listing => !listing.featured);
    properties.push({
      label: 'Number of Comparable Listings',
      value: selectedListings.length,
    }, {
      label: 'Comparable Listings Chosen',
      value: selectedListings.map(listing => listing.propertyId),
    });
  }
};